import { AzureBlobStorageHelper } from './azure-blob-storage-helper';
import Cookies from 'js-cookie';

// Retrieve value of window.msh.siteUrl. It is being set in the html head of the page layout.
// The environment specific msh:siteurl app setting is being used.
// For cases where this js is being used on the MSH site, then window.msh.siteUrl will be empty string since
// the URL paths are relative.
const MSH_SITE_URL = (((typeof window.msh === 'undefined') || (typeof window.msh.siteUrl === 'undefined')) ? '' : window.msh.siteUrl.endsWith('/') ? window.msh.siteUrl.slice(0, -1) : window.msh.siteUrl);

//---------------------------------------------------------------------------------------------
// Description:
//  - Libary bridges UI and the AzureBoxStorageHelper functionality
//  - Supports passing files from UI into module and support uploading files to ABS with
//    progress.
// Depends On:
//  - AzureBlobStorageHelper module
//---------------------------------------------------------------------------------------------
export function AzureFileUploadHelper() {
    let obj = {
        initialize: initialize,
        azureBlobHelper: null,
        addFilesWithInputId: addFilesWithInputId,
        uploadFiles: uploadFiles,
        files: [],
        fileInputFieldIds: [],
        isLoggedInMSHUserRequired: false,
        lotCostCenterId: null,
        adId: null,
        isMSHLoggedIn: false 
    };
    return obj;

    //---------------------------------------------------------------------------------------------
    // Description:
    //  - Initialize this file upload helper
    // Parameters:
    //  - config object 
    // {
    //      fileInputFieldIds: <array of dom ids of file input fields>,
    //      isLoggedInMSHUserRequired: <bool true if upload requires a logged in MSH user, false otherwise>,
    //      lotCostCenterId: <lotcostcenterid that the uploaded assets will be associated to>
    //      storageContext: "service-request" | "resale-owner-verification"
    //        - the storageContext is passed to the Config() or RestrictedConfig() endpoint to pull
    //          down settings and token for use with the Azure upload.  The server determines
    //          whether the settings point to a production vs non-production storage accounts.
    //          (See app.settings on the server side)
    // }
    //
    //---------------------------------------------------------------------------------------------
    function initialize(config) {
        if (!config) {
            throw "config cannot be null or empty";
        }

        if (!config.hasOwnProperty('fileInputFieldIds') || config.fileInputFieldIds.length == 0) {
            throw "fileInputFieldIds is missing or empty";
        }

        if (!config.hasOwnProperty('isLoggedInMSHUserRequired')) {
            throw "isLoggedInMSHUserRequired property is missing";
        }

        if (!config.hasOwnProperty('lotCostCenterId') || !config.lotCostCenterId) {
            throw "lotCostCenterId property is missing";
        }

        if (!config.hasOwnProperty('storageContext') || !config.storageContext) {
            throw "storageContext property is missing";
        }

        obj.fileInputFieldIds = config.fileInputFieldIds;
        obj.isLoggedInMSHUserRequired = config.isLoggedInMSHUserRequired;
        obj.lotCostCenterId = config.lotCostCenterId;
        obj.storageContext = config.storageContext;
        obj.adId = config.adId;
    }

    //---------------------------------------------------------------------------------------------
    // Description
    //  - Call to add the files given the ID of an <input type=file/> element
    // Notes:
    //  - Pushes all files associated with the input element (although the current UI
    //    only allows for selecting one file per input element)
    //---------------------------------------------------------------------------------------------
    function addFilesWithInputId(elementID) {
        var element = document.getElementById(elementID);
        if (element && element.files && element.files.length > 0)
        {
            var i = 0;
            for (i = 0; i < element.files.length; i++)
            {
                var file = element.files[i];
                file.id = obj.fileId;
                obj.fileId++;
                file.elementID = elementID;
                obj.files.push(file);
            };
        } 
    }
    
    //---------------------------------------------------------------------------------------------
    // Description
    //  - Callback function called by the AzureBlobStorageHelper function (lower level module)
    //    with progress information.  This function calculates the percent progress and
    //    supports calling an UI callback function (if specified).
    //---------------------------------------------------------------------------------------------
    function cbFileProgress(progress) {
        // console.log("inputID:" + this.inputID + " file:" + this.name + " progress: " + progress);
        if (this.onProgressUI)
        {
            // progress.loadedBytes - contains progress (from caller)
            progress.totalByes = this.size;
            progress.percent = (progress.loadedBytes * 100) / progress.totalByes;
            progress.elementID = this.elementID;
            progress.file = this;
            this.onProgressUI(progress);
        }
    }

    //---------------------------------------------------------------------------------------------
    // Description
    //  - Called by the UI to upload files to Azure Blob Storage. Files uploaded to ABS will contain the following
    //    hierarchy:
    //      storage account -> container name -> file group (which contains date/time stamp)
    //                      -> blob file names
    //---------------------------------------------------------------------------------------------
    function uploadFiles(uploadCompleteCallback, fileUploadStatusCallback) {
        obj.fileId = 1;
        obj.fileInputFieldIds.forEach(function(elementId) {
            obj.addFilesWithInputId(elementId);
        });

        obj.filesUploaded = [];

        $.ajax(MSH_SITE_URL + '/azureblobstorageapi/config?storagecontext=' + obj.storageContext,
        {
            type: 'GET',
            xhrFields: {
                withCredentials: true
            },
            success: function (response) {
                //ajax call to retrieve blob token
                if (response && response.IsSuccess) {
                    let containerName = response.Container;
                    let storageDomain = response.StorageDomain;
                    let accessDomain = response.AccessDomain;
                    let token = response.Token;
                    let adId = response.ADID;

                    // Temporary Kludge
                    if (!adId || adId.length == 0) {
                        adId = obj.adId;
                    }
                    // End Temporary Kludge - TODO remove

                    let isMSHLoggedIn = response.IsMSHLoggedIn;

                    obj.azureBlobHelper = AzureBlobStorageHelper();
                    obj.azureBlobHelper.initialize(
                        storageDomain,
                        containerName,
                        token,
                        adId,
                        isMSHLoggedIn,
                        accessDomain);

                    let upload = new Promise(function (resolve, reject) {
                        let blobHelper = obj.azureBlobHelper;
                        blobHelper.createFileGroup(adId, obj.lotCostCenterId).then(function (fileGroup) {
                            var files = obj.files;
                            for (const key in files) {
                                files[key].onProgressUI = fileUploadStatusCallback;
                                files[key].onProgress = cbFileProgress.bind(files[key]);
                            }
                            blobHelper.uploadFiles(fileGroup, files, obj.lotCostCenterId).then(
                                function (result) {
                                    var files = [];
                                    for (const key in result) {

                                        files.push(result[key]);

                                        if (fileUploadStatusCallback) {
                                            var progress = {
                                                file: result[key],
                                                id: result[key].id,
                                                elementID: result[key].elementID,
                                                succeeded: true
                                            };

                                            //Let the fileUploadCallback know that the individual file is complete.
                                            fileUploadStatusCallback(progress);
                                        }
                                    }

                                    // Reverse the order soo the filesUploaded array has the right file order
                                    for (const key in files) {
                                        obj.filesUploaded.push(files[key]);
                                    }

                                    //All of the files have been successfully uploaded.
                                    if (resolve) resolve({ succeeded: true });
                                },
                                function () {
                                    var err = { error: true, errorMsg: "Failed uploading file" };
                                    if (reject) reject(err);
                                });
                        },
                            function (err) {
                                var errObj = { error: true, errorMsg: "Failed creating storage group", err: err };
                                if (reject) reject(errObj);
                            });
                    }).then(
                        function (successObj) {
                            //Successful completion
                            if (uploadCompleteCallback) {
                                uploadCompleteCallback(true, successObj);
                            }
                        },
                        function (errObj) {
                            //Unsuccessful completion
                            if (uploadCompleteCallback) {
                                uploadCompleteCallback(false, errObj);
                            }
                        }
                    );
                }
                else if (!response.IsSuccess && !response.IsMSHLoggedIn) {
                    // User session ended
                    handleBadResponse(uploadCompleteCallback, response);
                }
            },
            error: function (error) {
                handleBadResponse(uploadCompleteCallback, response);
            }
        });
    } 

    //---------------------------------------------------------------------------------------------
    // Description
    //  - Called by uploadFiles when the Ajax to Azure Blob Storage hits an invalid/error response
    //---------------------------------------------------------------------------------------------
    function handleBadResponse(uploadCompleteCallback, response) {
        if (uploadCompleteCallback) {
            var response = {
                Success: false,
                Failed: true,
                Message: "An unexpected error occured. Please try again.",
                Detail: "Error occurred downloading storage api configuration.",
                Code: "3333" // arbitrary - no standardized codes across system
            };
            uploadCompleteCallback(false, response.Message, response); // redundant but needed for backwards compatibility
        }
    }
}
